module.exports = __webpack_public_path__ + "static/media/pickup.020291dd.svg";